import { FC, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import {
    BodyText1,
    InternalLink,
    Modal,
    ModalBody,
    ModalButton,
    ModalFooter,
    ModalHeader,
} from '@portal/common/components';
import { styled } from '@portal/common/theme';

import _ from '../../../locale';
import { DATA_EXPLORER_PATH } from '../../../router/paths';
import { setNotificationShown, updateAccount } from '../../../store/session/actions';
import { getSessionAccountId } from '../../../store/session/selectors';

const StyledModal = styled(Modal)({
    marginTop: 150,
});

const StyledHeader = styled(ModalHeader)({
    marginTop: 10,
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 50,
    paddingLeft: 50,
});

const BodyText1Styled = styled(BodyText1)(({ theme }) => ({
    marginTop: 20,
    marginLeft: 20,
    fontWeight: theme.typography.fontWeight.roman,
}));

const ModalBodyStyled = styled(ModalBody)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
});

const NewGBDBecomesDefaultPopup: FC = memo(() => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const accountId = useSelector(getSessionAccountId);

    const handleClose = useCallback(() => {
        if (accountId) {
            dispatch(setNotificationShown(true));
            dispatch(updateAccount({ is_notification_shown: true }));
        }
    }, [accountId, dispatch]);

    const handleExploreClick = useCallback(() => {
        handleClose();
        navigate(DATA_EXPLORER_PATH);
    }, [handleClose, navigate]);

    const LinkToDEX = (props) => (
        <InternalLink {...props} to={DATA_EXPLORER_PATH} onClick={handleClose} />
    );

    return (
        <StyledModal show onHide={handleClose}>
            <StyledHeader closeButton>
                {_('notification_new_gbd_becomes_default_title')}
            </StyledHeader>
            <ModalBodyStyled>
                <BodyText1Styled>
                    {_('notification_new_gbd_becomes_default_message')(LinkToDEX)}
                </BodyText1Styled>
            </ModalBodyStyled>
            <ModalFooter>
                <ModalButton type="submit" onClick={handleExploreClick}>
                    {_('explore_now_button')}
                </ModalButton>
            </ModalFooter>
        </StyledModal>
    );
});

export default NewGBDBecomesDefaultPopup;
